module.exports = __webpack_public_path__ + "static/logo-eternos-campeones-9db9f8874b99cad03eab0c3c5e623779.svg";